import script from "./ManageMemberModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ManageMemberModal.vue?vue&type=script&lang=ts&setup=true"

import "./ManageMemberModal.vue?vue&type=style&index=0&id=4a09897a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a09897a"]])

export default __exports__